const loaderReducer = (state = {}, action) => {
  const exclusions = ['REPORTING_UNITS_GROUP_RESTAURANTS_FETCH'];

  if (!exclusions.includes(action.payload)) {
    switch (action.type) {
      case '@@loader/ACTIVE':
        return {
          ...state,
          [action.payload]: true,
        };

      case '@@loader/INACTIVE':
        return {
          ...state,
          [action.payload]: false,
        };
    }
  }
  return state;
};

export default loaderReducer;
